import type { GuideTourStep } from '../types'
import { assertUniqueValues } from './assertions'
import { GuideTourValidationError } from './errors'
import { validateGuideTourStepFields } from './validateGuideTourStepFields'

export const validateGuideTourWhenTargetMissing = (
  step: GuideTourStep,
  prefix: string
): void => {
  if (step.whenTargetMissing === undefined) {
    return
  }

  if (!step.targetId?.trim()) {
    throw new GuideTourValidationError(
      `${prefix}.whenTargetMissing requires ${prefix}.targetId`
    )
  }

  if (step.whenTargetMissing.length === 0) {
    throw new GuideTourValidationError(
      `${prefix}.whenTargetMissing must contain at least one alternate flow`
    )
  }

  step.whenTargetMissing.forEach((flow, flowIndex) => {
    const flowPrefix = `${prefix}.whenTargetMissing[${flowIndex}]`

    if (flow.steps.length === 0) {
      throw new GuideTourValidationError(
        `${flowPrefix}.steps must contain at least one step`
      )
    }

    flow.steps.forEach((alternateStep, index) => {
      validateGuideTourStepFields(alternateStep, index)
    })

    assertUniqueValues(
      flow.steps
        .map(alternateStep => alternateStep.targetId)
        .filter((targetId): targetId is string => Boolean(targetId?.trim())),
      `${flowPrefix}.steps[].targetId`
    )
  })
}
